
<!-- Plans and credit tab -->

<!-- Plan payment details -->
<h1 mat-dialog-title *ngIf="!plan">{{ 'PLAN.BILLING_SETUP' | translate }}</h1>

<!-- Change plan -->
<h1 mat-dialog-title *ngIf="plan">{{ 'PLAN.CHANGE_TO' | translate:plan }}</h1>

<!-- New plan saved -->
<div mat-dialog-content *ngIf="success">
    <div class="alert alert-success text-center p-5">
        <fa-icon icon="check-circle" size="2x"></fa-icon>
        <div translate>PLAN.SAVED</div>
    </div>
</div>

<!-- Plan change message -->
<div mat-dialog-content *ngIf="billingSetup && !success">
    <div *ngIf="plan" class="alert alert-warning text-center ">
        <div>{{'PLAN.CHANGE_TO_LONG' | translate:plan}} {{data.subscriptionYearly? ' yearly.' : ' monthly.'}}</div>
    </div>

  <!-- Error message -->
  <div *ngIf="error" class="alert alert-danger text-center ">
      <fa-icon icon="exclamation-triangle" size="2x"></fa-icon>
      <div>{{error}}</div>
  </div>

  <!-- Billing and invoices tab -->
  <div class="row">
    <div class="col-6">

      <!-- Billing contact heading -->
        <h4 translate class="mt-3">PLAN.BILLING_CONTACT</h4>
        
        <!-- Billing contact table -->
        <div *ngFor="let cur of BILLING_QMAP" qmap-question [qMap]="cur" [model]="billingSetup"></div>
       
        <!-- Country-->
        <mat-form-field>
        <mat-select required #country="ngModel"  name="country" [placeholder]="'PLAN.COUNTRY' | translate"  [(ngModel)]="billingSetup['billerCountry']">
          <mat-option *ngFor="let country of countryList" [value]="country.text">
            {{country.text}}
          </mat-option>
        </mat-select>
       </mat-form-field>
    </div>

    <!-- Payment method heading -->
    <div class="col-6">
        <h4 translate class="mt-3">PLAN.BILLING_CARD</h4>

        <!-- Add credit card -->
        <div class="p-3" *ngFor="let cur of billingSetup.cards"  (click)="billingSetup.source = cur.card; isNewCard = false"
        [ngClass]="{'primary-bg-light':cur.card == billingSetup.source}" id="add-card">
        
        <!-- Delete credit card -->
        <div class="float-right"><small><button (click)="removeCard(billingSetup.cards[0])" id="delete-card" mat-button color="warn"><fa-icon icon="trash" class="fa-fw mr-2"></fa-icon> {{ 'PLAN.DEL_CARD' | translate }}</button></small></div>
          <fa-icon [icon]="['fab','cc-' + cur.card_type]" class="fa-fw mr-2" size="2x"></fa-icon> **** **** **** {{ cur.card_last4 }}
         </div>

        <!-- Accepted credit cards -->
         <div class="p-3">
          {{ 'PLAN.ACCEPTED_CARD' | translate }}
        </div>

         <!-- Credit card details -->
        <div *ngIf="isNewCard" class="p-3">
          {{ 'PLAN.BILLING_CARD_ENTER' | translate }}
          <div id="card-element1" class="field"></div>
        </div>
    </div>
  </div>
</div>

<div mat-dialog-actions class="align-content-right" *ngIf="billingSetup && !success">

  <!-- Cancel payment details -->
  <button mat-button (click)="cancel()">{{ 'GENERIC.CANCEL' | translate }}</button>

  <!-- Update/save payment details -->
  <button color="primary" mat-button (click)="updateDetails()" [disabled]="updating || (billingSetup && !billingSetup['billerCountry'] || billingSetup['billerCountry'].length == 0 )"> {{ 'GENERIC.SAVE' | translate }}</button>
</div>